// removed by extract-text-webpack-plugin
module.exports = {"suggestions":"theme__suggestions___3UbjO","up":"theme__up___2-Ks7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModifyStudent/theme.css
// module id = 1590
// module chunks = 0